<div class="p-3 rounded-3">
    <div class="row mb-2">
        <div class="col-12 mb-3">
            <div class="titletoptables">
                <div class="leftsideicons">
                    <img src="../../assets/image/CouponCode-icon.png" alt="multiuser" />
                </div>
                <h3>{{ "Coupon Management" }}</h3>
            </div>
        </div>
        <div class="row position">
            <div class="col-md-12 kt-margin-bottom-20-mobile" style="display:flex;">
                <div class="col-md-2">
                    <div class="srchgrid texttarget">
                        <input class="searchtextbox" matInput (keyup)="filterData($any($event.target).value)"
                            [value]="searchString" placeholder="Search" autocomplete="off">
                        <div class="closeicon" (keydown.enter)="clearList()" (click)="clearList()"> <span
                                aria-hidden="true">&times;</span> </div>
                    </div>
                </div>
                <div class="col-md-10 toogle">
                    <div class="btn-group-offer">
                        <button type="button" class="btn btn-primary addBtn" (click)="opencouponCodeDialog(null)">Add
                            Coupon</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="position">
        <kendo-grid #grid [loading]='kendoLoading' [data]=" gridView" [filter]="state.filter"
            [sortable]="{mode: 'single'}" [columnMenu]="{ filter: true }" [pageSize]="state.take" [skip]="state.skip"
            [pageable]="gridView?.data?.length && gridView.data.length > 0 ? pageableWithAll : false"
            (pageChange)="pageChange($event)" [sort]="sort" (sortChange)="CouponCodeData ? sortChange($event): null"
            [resizable]="true" [reorderable]="true" filterable="menu" [filter]="state.filter" [selectable]="true"
            (dataStateChange)="CouponCodeData ? dataStateChange($event): null" [navigable]="true" [height]="gridHeight"
            (columnVisibilityChange)="onColumnVisibilityChange(grid)" (dblclick)="onRowDoubleClick($event)">
            <kendo-grid-column field="CouponCode" [width]="100" title="Coupon Code">
            </kendo-grid-column>
            <kendo-grid-column field="CouponDiscount" [width]="100" title="Discount Percentage">
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{ dataItem.CouponDiscount }}%
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="CouponCurrencyName" [width]="100" title="Currency Type">
            </kendo-grid-column>
            <kendo-grid-column field="StartDate" [width]="100" title="Start Date">
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{ dataItem.StartDate | date: 'dd/MM/YYYY' }}
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="EndDate" [width]="100" title="End Date">
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{ dataItem.EndDate | date: 'dd/MM/YYYY' }}
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="CreatedOn" [width]="100" title="Created Date">
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{ dataItem.CreatedOn | date: 'dd/MM/YYYY' }}
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="CreatedByName" [width]="100" title="Added By">
            </kendo-grid-column>
            <kendo-grid-column field="Action" [width]="100" title="Action">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <mat-slide-toggle [(ngModel)]="dataItem.IsActive" (change)="onToggleStatus(dataItem)"
                        [class.disabled-row]="dataItem.IsExpired">
                    </mat-slide-toggle>
                    <img src="../../assets/image/edit-appointment-icon.png" alt="Edit Appointment"
                        (keydown.enter)="opencouponCodeDialog(dataItem)" class="ico20 ms-2"
                        (click)="opencouponCodeDialog(dataItem)" [class.disabled-row]="dataItem.IsExpired" />
                </ng-template>
            </kendo-grid-column>
        </kendo-grid>
    </div>
</div>

<ng-template #couponCodeDialog>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header"
                style="margin-bottom:5px; display: flex; align-items: center; justify-content: space-between;">
                <h4 class="popup-title">{{action}} Coupon Code</h4>
                <div class="header-actions" style="display: flex; gap: 8px;">
                    <button mat-icon-button (click)="toggleMaximize()">
                        <mat-icon style="margin-top:-22px;">{{ isMaximized ? 'fullscreen_exit' : 'fullscreen'
                            }}</mat-icon>
                    </button>
                    <button type="button" class="btn-close" aria-label="Close" (click)="closeDialog()"></button>
                </div>
            </div>
            <div class="modal-body">
                <mat-dialog-content>
                    <form [formGroup]="addCouponCodeFrom" class="mat-form">

                        <!-- Row 1 -->
                        <div class="row">
                            <!-- Coupon Code -->
                            <div class="col-md-6">
                                <mat-form-field class="w-100 custom-blue">
                                    <mat-label>Coupon Code</mat-label>
                                    <input matInput formControlName="CouponCode" placeholder="Enter Coupon Code"
                                        maxlength="30" />
                                    <mat-error
                                        *ngIf="addCouponCodeFrom.get('CouponCode')?.touched && addCouponCodeFrom.get('CouponCode')?.invalid">
                                        <ng-container
                                            *ngIf="addCouponCodeFrom.get('CouponCode')?.errors?.['required'] || addCouponCodeFrom.get('CouponCode')?.errors?.['whitespace']">
                                            Coupon Code is required
                                        </ng-container>
                                        <ng-container
                                            *ngIf="addCouponCodeFrom.get('CouponCode')?.errors?.['maxlength']">
                                            Maximum 30 characters allowed
                                        </ng-container>
                                        <ng-container *ngIf="addCouponCodeFrom.get('CouponCode')?.errors?.['pattern']">
                                            Space & Special Characters are not allowed
                                        </ng-container>
                                    </mat-error>
                                </mat-form-field>
                            </div>

                            <!-- Discount Percentage -->
                            <div class="col-md-4">
                                <mat-form-field class="w-100 custom-blue">
                                    <mat-label>Discount Percentage</mat-label>
                                    <input matInput type="number" formControlName="CouponDiscount" min="1" max="100"
                                        placeholder="Enter Percentage (1–100%)" (keypress)="onlyNumbers($event)" />
                                    <mat-error
                                        *ngIf="addCouponCodeFrom.get('CouponDiscount')?.touched && addCouponCodeFrom.get('CouponDiscount')?.invalid">
                                        <ng-container
                                            *ngIf="addCouponCodeFrom.get('CouponDiscount')?.errors?.['required']">
                                            Percentage is required
                                        </ng-container>
                                        <ng-container *ngIf="addCouponCodeFrom.get('CouponDiscount')?.errors?.['min']">
                                            Minimum value is 1
                                        </ng-container>
                                        <ng-container *ngIf="addCouponCodeFrom.get('CouponDiscount')?.errors?.['max']">
                                            Maximum value is 100
                                        </ng-container>
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="col-md-2">
                                <mat-form-field class="w-100 custom-blue">
                                    <mat-label>Currency</mat-label>
                                    <mat-select formControlName="CouponCurrencyId" 
                                        [panelClass]="'custom-select-panel'" [disableOptionCentering]="true">
                                        <mat-option *ngFor="let currency of currencyMap" [value]="currency.Id">
                                            {{ currency.CurrencyCode }} ({{ currency.CurrencySymbol }})
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>

                        <!-- Row 2 -->
                        <div class="row">
                            <!-- Start Date -->
                            <div class="col-md-6">
                                <mat-form-field class="w-100 custom-blue">
                                    <mat-label>Start Date</mat-label>
                                    <input matInput [matDatepicker]="startPicker" formControlName="StartDate"
                                        placeholder="Select start date" />
                                    <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                                    <mat-datepicker #startPicker></mat-datepicker>

                                    <mat-error
                                        *ngIf="addCouponCodeFrom.get('StartDate')?.touched && addCouponCodeFrom.get('StartDate')?.invalid">
                                        <ng-container *ngIf="addCouponCodeFrom.get('StartDate')?.errors?.['required']">
                                            Start date is required
                                        </ng-container>
                                        <ng-container *ngIf="addCouponCodeFrom.get('StartDate')?.errors?.['pastDate']">
                                            Start date must be today or later
                                        </ng-container>
                                    </mat-error>
                                </mat-form-field>
                            </div>

                            <!-- End Date -->
                            <div class="col-md-6">
                                <mat-form-field class="w-100 custom-blue">
                                    <mat-label>End Date</mat-label>
                                    <input matInput [matDatepicker]="endPicker" formControlName="EndDate"
                                        placeholder="Select end date" />
                                    <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                                    <mat-datepicker #endPicker></mat-datepicker>

                                    <mat-error *ngIf="addCouponCodeFrom.get('EndDate')?.touched">
                                        <ng-container *ngIf="addCouponCodeFrom.get('EndDate')?.errors?.['required']">
                                            End date is required
                                        </ng-container>
                                        <ng-container
                                            *ngIf="addCouponCodeFrom.get('EndDate')?.errors?.['endBeforeStart']">
                                            End date cannot be earlier than start date
                                        </ng-container>
                                        <ng-container *ngIf="addCouponCodeFrom.get('EndDate')?.errors?.['pastDate']">
                                            End date cannot be earlier than today
                                        </ng-container>
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>

                    </form>
                </mat-dialog-content>
                <mat-dialog-actions align="end">
                    <button mat-raised-button (click)="closeDialog()" style="margin-right: 10px;" type="button"
                        class="btn btn-secondary" tabindex="-1">Cancel</button>
                    <button mat-raised-button type="button" class="btn btn-primary"
                        (click)="submitCouponCode()">{{this.action}}</button>
                </mat-dialog-actions>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #updateStatusDialog>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header" style="margin-bottom:5px">
                <h4 class="popup-title">Update Status Confirmation</h4>
                <button type="button" class="btn-close" aria-label="Close" mat-dialog-close
                    (click)="Noupdate()"></button>
            </div>
            <div class="modal-body">
                <mat-dialog-content>
                    <div>Are you sure you want to update status?</div>
                </mat-dialog-content>
                <mat-dialog-actions align="end" style="gap:20px;">
                    <button mat-raised-button style="margin-left: 20px;" type="button" class="btn btn-secondary"
                        tabindex="-1" (click)="Noupdate()" mat-dialog-close>No</button>
                    <button mat-raised-button type="button" (click)="updateStatus()" class="btn btn-primary"
                        tabindex="0">Yes</button>
                </mat-dialog-actions>
            </div>
        </div>
    </div>
</ng-template>